export enum RecaptchaActionNames {
  CLAIM_QR_CLAIM_EMAIL = 'CLAIM_QR_CLAIM_EMAIL',
  EVENT_VALIDATE = 'EVENT_VALIDATE',
  WEBSITE_GET = 'WEBSITE_GET',
  WEBSITE_CLAIM = 'WEBSITE_CLAIM',
  DELIVERY_ADD_ADDRESSES = 'DELIVERY_ADD_ADDRESSES',
  DELIVERY_CREATE = 'DELIVERY_CREATE',
  SECRET_CREATE = 'SECRET_CREATE',
  REDEEM_REQUEST_CREATE = 'REDEEM_REQUEST_CREATE',
  TOKEN_FREEZE = 'TOKEN_FREEZE',
  SECRET_UPDATE = 'SECRET_UPDATE',
  EVENT_UPDATE = 'EVENT_UPDATE',
  SECRET_GET_BY_EVENT_CODE = 'SECRET_GET_BY_EVENT_CODE',
}
